import { FC } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { pdfjs } from 'react-pdf';

import { LanguagesCode } from 'src/i18n/constants';
import { initI18Next } from 'src/i18n/instance';
import { Routing } from 'src/layout';
import { Layout } from 'src/layout/layout';
import { useGetBasketById } from 'src/lib/hooks/use-get-basket-by-id';

initI18Next(LanguagesCode.English);

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.js`;

export const App: FC = () => {
    const methods = useForm();
    useGetBasketById();

    return (
        <FormProvider {...methods}>
            <Layout>
                <Routing />
            </Layout>
        </FormProvider>
    );
};
